// extracted by mini-css-extract-plugin
export var arrowNext = "pager-module--arrowNext--2YA5P";
export var arrowPrevious = "pager-module--arrowPrevious--ZMenR";
export var next = "pager-module--next--285E+";
export var previous = "pager-module--previous--Yw+CM";
export var previousArrowWrapper = "pager-module--previousArrowWrapper--lretW";
export var wrapper = "pager-module--wrapper--q8NXP";